import React from "react";
import { IoCheckmarkSharp } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";
import { useLocalStorage } from "react-use";

import { ActionButton } from "./buttons";

import * as styles from "./privacyWarning.module.scss";

function PrivacyWarning() {
  const [value, setValue, remove] = useLocalStorage("privacy-accept", false);

  return (
    <AnimatePresence>
      {!value && (
        <motion.div
          initial={{ y: "100%" }}
          animate={{ y: 0 }}
          exit={{ y: "100%" }}
          transition={{
            type: "spring",
            damping: 20,
          }}
          className={styles.container}
        >
          <div className={styles.wrap}>
            <div className={styles.text}>
              <p>
                Оставляя свои контактные данные на сайте, вы соглашаетесь на
                обработку ваших персональных данных.
              </p>
              <a href="/privacy/" target="_blank">
                Политика конфиденциальности
              </a>
            </div>
            <div className={styles.action}>
              <ActionButton
                isPending={false}
                name="Принять"
                icon={<IoCheckmarkSharp className="icon no-rotate" />}
                className="link wide orange"
                onClick={() => setValue(true)}
              />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default PrivacyWarning;
